export interface LuaTemplate {
  id: string;
  name: string;
  description: string;
  category: string;
  prompt?: string;
  codeTemplate?: string;
  placeholders?: string[];
  examples?: string[];
}

export const LUA_TEMPLATES: LuaTemplate[] = [
  {
    id: 'extract-user-info',
    name: 'Extract User Info',
    description: 'Extracts user name and email from input and creates a new object.',
    category: 'data-transformation',
    prompt: 'Extract user name from input.user.name and user email from input.user.email. Create an output object with "fullName" and "email" properties.',
    codeTemplate: `-- Example: Extract User Info
local result = {}
result.fullName = input.user.name
result.email = input.user.email
return result`,
    placeholders: [],
    examples: []
  },
  {
    id: 'calculate-age-category',
    name: 'Calculate Age Category',
    description: 'Calculates age category (minor/adult) based on input.user.age.',
    category: 'data-enrichment',
    prompt: 'Calculate age category based on input.user.age. If age is less than 18, category is "minor", otherwise "adult".',
    codeTemplate: `-- Example: Calculate Age Category
local result = {}
local user_age = input.user.age
result.ageCategory = user_age < 18 and "minor" or "adult"
return result`,
    placeholders: [],
    examples: []
  },
  {
    id: 'combine-properties',
    name: 'Combine Properties',
    description: 'Combines two input properties into a new output property.',
    category: 'data-transformation',
    prompt: 'Combine input.firstName and input.lastName into a new output property called "full_name".',
    codeTemplate: `-- Example: Combine Properties
local result = {}
result.full_name = input.firstName .. " " .. input.lastName
return result`,
    placeholders: [],
    examples: []
  },
  {
    id: 'conditional-output',
    name: 'Conditional Output',
    description: 'Generates output based on a condition.',
    category: 'logic',
    prompt: 'If input.event.name is "purchase", set output.isPurchase to true, otherwise false.',
    codeTemplate: `-- Example: Conditional Output
local result = {}
if input.event.name == "purchase" then
  result.isPurchase = true
else
  result.isPurchase = false
end
return result`,
    placeholders: [],
    examples: []
  },
];

export const getLuaTemplateIcon = (templateId: string) => {
  const iconMap: Record<string, React.ComponentType<any>> = {
    'extract-user-info': User, // Assuming User icon from lucide-react
    'calculate-age-category': DollarSign, // Assuming DollarSign icon
    'combine-properties': Code, // Assuming Code icon
    'conditional-output': Filter, // Assuming Filter icon
  };
  return iconMap[templateId] || Sparkles; // Default to Sparkles
};

// You might need to import these icons from lucide-react
import { User, DollarSign, Code, Filter, Sparkles } from 'lucide-react';
